"use client";

import React from "react";
import PageBuilder from "../pageBuilder/PageBuilder";
import PostHeader from "./components/PostHeader";
import Wrapper from "@/components/ui/Wrapper";
import PostAside from "./components/PostAside";

type Props = {
  data: unknown; // keeping flexible to match your WPEntry shape
  lang?: string; // passed from server PageContent
};

export default function PageContentClient({ data, lang }: Props) {
  const d = data as { acf?: unknown } | null;
  const acf = (d && typeof d === "object" ? (d as { acf?: unknown }).acf : undefined) ?? {};

  // Post vs Page builder detection (same logic you already used)
  const a = acf as {
    content_post_builder?: unknown;
    content_builder?: unknown;
  };

  const postBlocks = (a?.content_post_builder ?? []) as unknown[];
  const pageBlocks = (a?.content_builder ?? []) as unknown[];

  const isPost = Array.isArray(postBlocks) && postBlocks.length > 0;
  const blocks = isPost ? postBlocks : pageBlocks;

  // Nothing to render
  if (!Array.isArray(blocks) || blocks.length === 0) {
    return null;
  }

  return (
    <>
      {/* Post header only for posts */}
      {isPost ? <PostHeader data={data as never} blocks={blocks as never} /> : null}

      {/* Post layout with aside */}
      {isPost ? (
        <Wrapper>
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
            <aside className="lg:col-span-4">
              <PostAside />
            </aside>

            <div className="lg:col-span-8">
              <PageBuilder data={blocks as never} lang={lang} />
            </div>
          </div>
        </Wrapper>
      ) : (
        /* Normal page layout */
        <PageBuilder data={blocks as never} lang={lang} />
      )}
    </>
  );
}
